export class OrderBy  {

    constructor(property: string) {
        this.property = property;
        this.ascending = true;
    }

    property : string;
    ascending : boolean;
}